import { render, staticRenderFns } from "./KpiContentPopup.vue?vue&type=template&id=03255c36&scoped=true&"
import script from "./KpiContentPopup.vue?vue&type=script&lang=ts&"
export * from "./KpiContentPopup.vue?vue&type=script&lang=ts&"
import style0 from "./KpiContentPopup.vue?vue&type=style&index=0&id=03255c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03255c36",
  null
  
)

export default component.exports